(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amavi-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FULL = '<svg width="SZ" height="SZ" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l2.9 6.26 6.85.74-5.1 4.63 1.4 6.74L12 16.9 5.95 20.37l1.4-6.74-5.1-4.63 6.85-.74z"/></svg>';
  var EMPTY = '<svg width="SZ" height="SZ" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.5l2.47 5.33 5.83.63-4.34 3.94 1.19 5.74L12 16.2l-5.15 2.94 1.19-5.74-4.34-3.94 5.83-.63z"/></svg>';
  function stars(n, size) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += (i <= n ? FULL : EMPTY).split('SZ').join(size);
    return out;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }
  function init(root) {
    if (root.dataset.revInit) return;
    root.dataset.revInit = '1';
    var page = parseInt(root.dataset.page, 10) || 10;
    var list = root.querySelector('[data-rev-list]');
    var more = root.querySelector('[data-rev-more]');
    var emptyMsg = root.querySelector('[data-rev-empty]');
    fetch(root.dataset.src, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (data) {
        if (!Array.isArray(data)) data = [];
        data = data.filter(function (r) { return r && r.testo; });
        if (!data.length) { emptyMsg.hidden = false; return; }
        var tot = data.length, sum = 0, dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        data.forEach(function (r) { var s = Math.min(5, Math.max(1, parseInt(r.stelle, 10) || 5)); r._s = s; sum += s; dist[s]++; });
        var avg = (sum / tot).toFixed(1).replace('.', ',');
        root.querySelector('[data-rev-avgstars]').innerHTML = stars(Math.round(sum / tot), 20);
        root.querySelector('[data-rev-avg]').textContent = avg + ' de 5';
        var manual = parseInt(String(root.dataset.total || '').replace(/\D/g, ''), 10);
        var showTot = manual > 0 ? manual : tot;
        root.querySelector('[data-rev-count]').textContent = root.dataset.suffix.replace('{n}', showTot);
        var bars = root.querySelector('[data-rev-bars]');
        for (var s = 5; s >= 1; s--) {
          var row = el('div', 'amavi-rev__bar-row');
          var st = el('span', 'amavi-rev__bar-stars');
          st.setAttribute('aria-hidden', 'true');
          st.innerHTML = stars(s, 13);
          var track = el('span', 'amavi-rev__bar-track');
          var fill = el('span', 'amavi-rev__bar-fill');
          fill.style.width = Math.round(dist[s] * 100 / tot) + '%';
          track.appendChild(fill);
          var barN = manual > 0 ? Math.round(dist[s] * manual / tot) : dist[s];
          row.appendChild(st); row.appendChild(track); row.appendChild(el('span', 'amavi-rev__bar-n', String(barN)));
          bars.appendChild(row);
        }
        var shown = 0;
        function batch() {
          var end = Math.min(shown + page, tot);
          for (; shown < end; shown++) list.appendChild(card(data[shown]));
          more.hidden = shown >= tot;
        }
        function card(r) {
          var c = el('article', 'amavi-rev__card');
          var top = el('div', 'amavi-rev__card-top');
          var st = el('span', 'amavi-rev__stars');
          st.setAttribute('aria-label', r._s + ' estrellas de 5');
          st.innerHTML = stars(r._s, 16);
          top.appendChild(st);
          if (r.data) top.appendChild(el('span', 'amavi-rev__date', r.data));
          c.appendChild(top);
          var who = el('div', 'amavi-rev__who');
          var av = el('span', 'amavi-rev__avatar');
          av.setAttribute('aria-hidden', 'true');
          av.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="8" r="3.4"/><path d="M4.5 20c1.6-3.4 4.3-5 7.5-5s5.9 1.6 7.5 5"/></svg>';
          who.appendChild(av);
          who.appendChild(el('span', 'amavi-rev__name', r.nome || 'Anónimo'));
          if (r.verificato) who.appendChild(el('span', 'amavi-rev__verified', root.dataset.verified));
          c.appendChild(who);
          c.appendChild(el('p', 'amavi-rev__text', r.testo));
          if (r.foto) {
            var mw = el('div', 'amavi-rev__media');
            var img = document.createElement('img');
            img.src = r.foto; img.loading = 'lazy'; img.alt = root.dataset.photoAlt || 'Foto de la reseña';
            mw.appendChild(img); c.appendChild(mw);
          }
          if (r.video) {
            var vw = el('div', 'amavi-rev__media');
            var vid = document.createElement('video');
            vid.src = r.video; vid.controls = true; vid.preload = 'none';
            vw.appendChild(vid); c.appendChild(vw);
          }
          if (r.risposta) {
            var rp = el('div', 'amavi-rev__reply');
            rp.appendChild(el('p', 'amavi-rev__reply-label', root.dataset.reply));
            rp.appendChild(el('p', 'amavi-rev__reply-text', r.risposta));
            c.appendChild(rp);
          }
          return c;
        }
        more.addEventListener('click', batch);
        batch();
      })
      .catch(function () { emptyMsg.hidden = false; });
  }
  document.querySelectorAll('[data-amavi-rev]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target || document;
    if (scope.querySelectorAll) scope.querySelectorAll('[data-amavi-rev]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
